/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { supportBlockerV4NameSchema } from './supportBlockerV4NameSchema'

export const supportSummaryV4Schema = z
  .object({
    blockers: z
      .array(supportBlockerV4NameSchema)
      .nullish()
      .describe('Blocker names, in the order the user meets them on a real login.'),
    lockedOut: z.boolean().optional().describe('True while the account is locked out.'),
    lockoutEnd: z.iso
      .datetime({ offset: true, local: true })
      .nullish()
      .describe('UTC end of the current lockout; null when not locked out.'),
    trustedDevices: z
      .int()
      .optional()
      .describe(
        "Number of the user's still-valid trusted devices (browsers that skip the login code)."
      ),
  })
  .describe(
    "Summary of the target user's login blockers, shown to the support user after `loginAs`."
  )
